var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCv = function SvgCv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003893",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M22.395 18A11.945 11.945 0 0 0 24 12H0c0 2.186.584 4.235 1.605 6h20.79Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF2027",
    fillRule: "evenodd",
    d: "M.16 13.958H23.84A11.91 11.91 0 0 1 23.317 16H.683a11.915 11.915 0 0 1-.524-2.042Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D116",
    fillRule: "evenodd",
    d: "m10.601 20.847-.254-.783-.254.783h-.822l.665.483-.254.783.665-.484.666.483-.254-.782.665-.483h-.822Zm-5.749-3.975-.254-.78-.254.78H3.52l.666.483-.255.78.666-.482.666.483-.255-.781.666-.483h-.823Zm-.068-4.085-.254-.78-.254.78h-.823l.666.482-.255.78.666-.482.666.483-.255-.781.666-.482h-.823Zm11.633 0-.255-.778-.254.779h-.823l.666.481-.254.78.665-.482.666.481-.254-.779.665-.481h-.823Zm-.076 4.086-.255-.78-.254.78h-.822l.665.482-.254.779.666-.482.665.482-.254-.78.666-.481h-.823Zm-5.997-9.068.255.783h.822l-.665.483.254.783-.666-.484-.665.484.254-.783-.665-.483h.822l.254-.783ZM6.75 8.972l.254.782h.823l-.666.484.254.782-.665-.483-.666.483.254-.782-.665-.484h.822l.255-.782Zm7.442 10.71-.254-.782-.255.783h-.822l.665.483-.254.783.666-.484.665.484-.254-.783.666-.483h-.823Zm-7.062.093-.254-.782-.254.782h-.823l.665.484-.254.782.666-.483.665.483-.254-.782.666-.484h-.823Zm6.958-10.11-.255-.783-.254.782h-.822l.665.484-.254.782.666-.483.665.483-.254-.782.665-.484h-.822Z",
    clipRule: "evenodd"
  })));
};
export default SvgCv;